import { enableProdMode, ErrorHandler, isDevMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import { ErrorHandlerService } from './app/global-services/ErrorHandlerService';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RequestInterceptor } from './app/request.interceptor';
import { AuthInterceptor as AcsChatAuthInterceptor } from './app/acs-chat/services/auth.interceptor';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { CustomNativeDateAdapter, CUSTOM_NATIVE_DATE_FORMATS } from './app/utilities/custom-date-adapters/custom-native-date-adapter';
import { MAT_SELECT_SCROLL_STRATEGY_PROVIDER } from '@angular/material/select';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { SharedDirectivesModule } from './app/utilities/shared-directives/shared-directives.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgIdleModule } from '@ng-idle/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AppComponent } from './app/app.component';

// Registering Syncfusion license key
registerLicense(environment.syncfusionLicenseKey);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, MatProgressSpinnerModule, MatTooltipModule, MatDividerModule, MatExpansionModule, MatDialogModule, MatSnackBarModule, MatSidenavModule, MatAutocompleteModule, MatFormFieldModule, ReactiveFormsModule, MatInputModule, MatIconModule, MatButtonModule, MatMenuModule, SharedDirectivesModule, CKEditorModule, NgIdleModule.forRoot(), ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }), MatChipsModule, MatDatepickerModule, MatNativeDateModule),
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AcsChatAuthInterceptor, multi: true },
        { provide: DateAdapter, useClass: CustomNativeDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_NATIVE_DATE_FORMATS },
        MAT_SELECT_SCROLL_STRATEGY_PROVIDER,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ]
})
  .catch(err => console.error(err));
